import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureFlagCollection } from '../../../../../../../shared/interfaces/feature-flag.interface';
import { IWorkspace } from '../../../../../../../shared/interfaces/workspace.interface';
import { FeatureFlagService } from '../../../../../services/feature-flag/feature-flag.service';
import { Nullable } from '../../../../../../../shared/interfaces/nullable.interface';

@Component({
  selector: 'app-create-tenant-workspace-selector',
  styleUrls: ['./create-tenant-workspace-selector.component.scss'],
  templateUrl: './create-tenant-workspace-selector.component.html',
  standalone: false,
})
export class CreateTenantWorkspaceSelectorComponent implements OnInit, OnDestroy {
  protected bulkWorkspaceCreation: Nullable<boolean> = null;
  public singleWorkspace: boolean = true;
  private subscription: Subscription;

  @Input() modalMode: boolean = false;
  @Input() tenantId: string;

  @Output() workspaceCreated: EventEmitter<IWorkspace> = new EventEmitter<IWorkspace>();
  @Output() bulkCreated: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelled: EventEmitter<void> = new EventEmitter<void>();

  constructor(private featureFlagService: FeatureFlagService) {
    this.subscription = new Subscription();
  }

  public ngOnInit(): void {
    this.subscription.add(
      this.featureFlagService
        .variation$(FeatureFlagCollection.bulkWsAndDpsCreationWithCustomMonitoringSettings, false)
        .pipe(map(Boolean))
        .subscribe({
          next: (value: boolean): void => {
            this.bulkWorkspaceCreation = value;
          },
          error: (): void => {
            this.bulkWorkspaceCreation = false;
          },
        }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
